import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { useSelector, ApiConfigSelectors } from '@grandvisionhq/state';

const useGetAdditionalCartCost = ()=>{
    const apiConfig = useSelector(ApiConfigSelectors.getApiConfig);
    const [additionalCosts, setAdditionalCosts] = React.useState([]);
    const getAdditionalCosts = React.useCallback(()=>{
        if (!apiConfig) {
            throw new Error('Need API URL to get additional cart costs.');
        }
        Products.query(apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.productsUrl, {
            // Main category is called additionalCartCosts, but the "products" are configured in additionalPaymentCost
            categoryType: 'additionalPaymentCost'
        }).then(({ results  })=>{
            if (results) {
                setAdditionalCosts(results);
            } else {
                setAdditionalCosts([]);
            }
        }).catch((error)=>{
            if (error instanceof Error) {
                console.error(error);
            } else {
                console.error('Unable to load additional cart cost');
            }
        });
    }, [
        apiConfig
    ]);
    return {
        getAdditionalCosts,
        additionalCosts
    };
};

export { useGetAdditionalCartCost };
//# sourceMappingURL=use-get-additional-cart-costs.js.map
